// NESTY BLOOM — Mochi, anfitrión virtual
// Widget de chat basado en reglas (sin backend externo), con la voz de Mochi.

document.addEventListener('DOMContentLoaded', function () {
  var icon = document.getElementById('nb-mochi-icon');
  var panel = document.getElementById('nb-mochi-panel');
  var idleBubble = document.getElementById('nb-mochi-idle-bubble');
  if (!icon || !panel) return;

  var closeBtn = panel.querySelector('.nb-mochi__close');
  var body = panel.querySelector('.nb-mochi__body');
  var form = panel.querySelector('.nb-mochi__form');
  var input = panel.querySelector('.nb-mochi__input');
  var chipsWrap = panel.querySelector('.nb-mochi__chips');

  var isOpen = false;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
  window.setInterval(function () {
    icon.classList.add('is-blinking');

    window.setTimeout(function () {
      icon.classList.remove('is-blinking');
    }, 180);

  }, 4500 + Math.random() * 2500);
}

  function openPanel() {
    isOpen = true;
    icon.classList.add('is-hidden');
    hideIdleBubble();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    window.setTimeout(function () { input && input.focus(); }, reduceMotion ? 0 : 260);
  }

  function closePanel() {
    isOpen = false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      icon.classList.remove('is-hidden');
    }, 200);
  }

  icon.addEventListener('click', openPanel);
  closeBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closePanel();
  });

  // ---- Mochi asoma cuando el visitante lleva un rato sin hacer nada ----
  var lastActivity = Date.now();
  var idleShown = false;
  var idleThreshold = 30000 + Math.random() * 15000; // 30–45s
  var idleHideTimer = null;

  function registerActivity() {
    lastActivity = Date.now();
    if (idleShown) hideIdleBubble();
  }
  ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, registerActivity, { passive: true });
  });

  function showIdleBubble() {
    if (isOpen || idleShown) return;
    idleShown = true;
    icon.classList.add('is-idle-peek');
    if (idleBubble) idleBubble.classList.add('is-visible');
    idleHideTimer = window.setTimeout(function () {
      hideIdleBubble();
      idleThreshold = 30000 + Math.random() * 15000;
      lastActivity = Date.now();
    }, 8000);
  }

  function hideIdleBubble() {
    idleShown = false;
    icon.classList.remove('is-idle-peek');
    if (idleBubble) idleBubble.classList.remove('is-visible');
    if (idleHideTimer) window.clearTimeout(idleHideTimer);
  }

  if (idleBubble) {
    idleBubble.addEventListener('click', function () {
      hideIdleBubble();
      openPanel();
    });
  }

  window.setInterval(function () {
    if (!isOpen && !idleShown && Date.now() - lastActivity >= idleThreshold) {
      showIdleBubble();
    }
  }, 2000);

  // ---- Motor de respuestas de Mochi ----
  function addMessage(html, from) {
    var el = document.createElement('div');
    el.className = 'nb-mochi__msg nb-mochi__msg--' + from;
    el.innerHTML = html;
    body.appendChild(el);
    body.scrollTop = body.scrollHeight;
  }

  function showTyping() {
    var t = document.createElement('div');
    t.className = 'nb-mochi__typing';
    t.innerHTML = '<span></span><span></span><span></span>';
    body.appendChild(t);
    body.scrollTop = body.scrollHeight;
    return t;
  }

  function answerFor(q) {
    q = q.toLowerCase();
    if (/(hola|buenas|hey|holi)/.test(q)) {
      return '¡Hola! Qué lindo tenerte por aquí 🌸 ¿en qué te ayudo?';
    }
    if (/(pedido|orden|estado|rastre|segu)/.test(q)) {
      return 'Puedes revisar el estado de tu pedido en el correo de confirmación, o desde <a href="/account">tu cuenta</a> 🐾 si necesitas ayuda directa, dime y te conecto con el equipo.';
    }
    if (/(regalo|obsequ)/.test(q)) {
      return '¡Me encanta ayudar con regalos! 🎁 ¿para qué ocasión es, o te muestro nuestros favoritos? <a href="/search?q=autocuidado">Ver ideas de regalo</a>';
    }
    if (/(cabello|pelo|moldeador|plancha|riz)/.test(q)) {
      return 'Para el cabello tenemos moldeadores, planchas y rizadores sin calor 💇 <a href="/search?q=cabello">Ver productos de cabello</a>';
    }
    if (/(ba[ñn]o|ducha|jab[oó]n|champ[uú])/.test(q)) {
      return 'Nuestra línea de baño y ducha es de las favoritas ✨ <a href="/search?q=ba%C3%B1o">Ver productos de baño</a>';
    }
    if (/(autocuidado|relajar|relax|spa|rutina)/.test(q)) {
      return 'El autocuidado es el corazón de Nesty Bloom 🌸 <a href="/search?q=autocuidado">Ver colección de autocuidado</a>';
    }
    if (/(env[ií]o|entrega|demora|lleg)/.test(q)) {
      return 'Tus pedidos salen en 24-48h hábiles y llegan en 3-7 días según tu comuna 📦';
    }
    if (/(pago|tarjeta|pagar|cuotas)/.test(q)) {
      return 'Tu compra siempre está protegida con pago 100% seguro ✨';
    }
    if (/(devol|cambio|garant[ií]a|reembolso)/.test(q)) {
      return 'Si algo no te convence, contamos con garantía de compra protegida — te acompañamos en todo el proceso 🌸';
    }
    if (/(persona|humano|equipo|ayuda real|hablar con)/.test(q)) {
      return 'Con gusto — escríbenos y el equipo de Nesty Bloom te responde a la brevedad 💬 <a href="/pages/contacto">Ir a contacto</a>';
    }
    if (/(producto|busco|encontrar)/.test(q)) {
      return '¿Buscas algo para el cabello, la ducha, o un ritual de autocuidado en general? 🌸';
    }
    if (/(gracias|genial|perfecto)/.test(q)) {
      return 'Con todo el gusto 🌸 aquí estaré si necesitas algo más.';
    }
    return 'Buena pregunta 🐾 cuéntame un poco más o dime qué tipo de producto buscas y te ayudo a encontrarlo.';
  }

  function respondTo(userText) {
    var typingEl = showTyping();
    window.setTimeout(function () {
      typingEl.remove();
      addMessage(answerFor(userText), 'mochi');
    }, 600 + Math.random() * 350);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var val = (input.value || '').trim();
    if (!val) return;
    addMessage(val.replace(/</g, '&lt;'), 'user');
    input.value = '';
    respondTo(val);
  });

  if (chipsWrap) {
    chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('.nb-mochi__chip');
      if (!chip) return;
      var text = chip.textContent.trim();
      addMessage(text, 'user');
      respondTo(text);
    });
  }
});
